import { api } from '@/shared/api/axios';
import { unwrapList } from '@/shared/api/unwrap';

export const usersApi = {
  list: (filters) => {
    const params = new URLSearchParams();
    if (filters?.deploymentId) params.set('deploymentId', filters.deploymentId);
    const qs = params.toString();
    return api.get(`/users${qs ? `?${qs}` : ''}`).then(unwrapList);
  },
  get: (id) => api.get(`/users/${id}`).then((r) => r.data),
  create: (payload) => api.post('/users', payload).then((r) => r.data),
  update: (id, payload) => api.patch(`/users/${id}`, payload).then((r) => r.data),
  delete: (id) => api.delete(`/users/${id}`).then((r) => r.data),
};
